// ============================================
// CLIENTE HTTP CENTRAL
// ============================================
// Único punto de acceso al backend. Aporta automáticamente:
//   - URL base (API_BASE_URL) para rutas que empiezan con /api/
//   - Header Authorization con el token de sesión
//   - Timeout (15 s por defecto, configurable con options.timeoutMs)
//   - Manejo global de sesión expirada (401 → logout, ver utils/helpers.js)
//   - Verificación de response.ok y parseo JSON (lanza Error con .status y .payload)
//
// Uso:
//   import { api } from '@/services/api';
//   const data = await api.get('/api/users?proyecto_id=1');
//   await api.post('/api/save-irrigation', payload);
//   try { ... } catch (e) { toasted(e.message, 'danger'); }
//
// Migración gradual: reemplazar fetch() crudos por api.* al tocar cada componente.

import { fetchWithToken, fetchJsonWithToken } from '../utils/helpers';

function withBody(method) {
  return (url, body, options = {}) =>
    fetchJsonWithToken(url, {
      ...options,
      method,
      body: body !== undefined ? JSON.stringify(body) : options.body
    });
}

export const api = {
  /** GET que devuelve JSON (lanza Error si !response.ok) */
  get: (url, options = {}) => fetchJsonWithToken(url, { ...options, method: 'GET' }),
  post: withBody('POST'),
  put: withBody('PUT'),
  patch: withBody('PATCH'),
  /** DELETE que devuelve JSON (lanza Error si !response.ok) */
  delete: (url, options = {}) => fetchJsonWithToken(url, { ...options, method: 'DELETE' }),
  /** Acceso a la Response cruda (para blobs, streaming, o manejo manual) */
  raw: (url, options = {}) => fetchWithToken(url, options)
};

export default api;
